import React from "react"
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {CmCollectionType, CmTeasableType} from "../../types";
import C000DefaultTeaser from "./C000DefaultTeaser";


export interface Props {
    cmCollection: CmCollectionType
}

function C000DefaultCollection(props: Props) {
    return <CCOComponentWrapper noTopMargin={!props.cmCollection.teaserTitle} noBottomMargin fullWidthOnMobile>
        <CCOHeadline metadataId={props.cmCollection.id} headline={props.cmCollection.teaserTitle}
                     type={"componenthead"}
                     propertyName='properties.teaserTitle'
                     subtextPropertyName='properties.teaserText'
                     subtext={props.cmCollection.teaserText?.textAsTree}/>

        <>
            {
                props.cmCollection.items?.map(i => i as CmTeasableType).map((i: CmTeasableType, index: number) =>
                    <C000DefaultTeaser cmTeasable={i} key={index}/>
                )
            }
        </>
    </CCOComponentWrapper>

}

export default C000DefaultCollection
